"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _quill = _interopRequireDefault(require("quill"));

require("quill/dist/quill.snow.css");

var _client = _interopRequireDefault(require("sharedb/lib/client"));

var _richText = _interopRequireDefault(require("rich-text"));

var _reconnectingWebsocket = _interopRequireDefault(require("reconnecting-websocket"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

_client["default"].types.register(_richText["default"].type);

var quillOptions = {
  theme: 'snow',
  modules: {
    toolbar: [{
      font: []
    }, 'bold', 'italic', 'underline', 'strike', {
      header: [1, 2, 3, 4, 5, 6, false]
    }, {
      color: []
    }, {
      background: []
    }, {
      align: []
    }, 'blockquote', 'code-block', // 'clean',
    {
      list: 'ordered'
    }, {
      list: 'bullet'
    }]
  },
  placeholder: 'Type here!'
};
/**
  @param {Object} props
  @param {string} props.docId
  @param {string} props.docCollection
  @param {string} props.id
  @param {WebSocket | undefined} props.socket
  @param {React.Component | undefined} props.spinner
  @param {React.RefObject | undefined} props.quillRef
  @param {string} props.userDisplayName
  @param {number} props.width
  @param {number} props.height
  @param {string} props.host
  @param {Object} props.initialData
*/

var CollaborativeQuill = function CollaborativeQuill(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      socketReady = _useState2[0],
      setSocketReady = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      subscribed = _useState6[0],
      setSubscribed = _useState6[1];

  var _useState7 = (0, _react.useState)(0),
      _useState8 = _slicedToArray(_useState7, 2),
      createAttempts = _useState8[0],
      setCreateAttempts = _useState8[1];

  var ready = socketReady && subscribed; // use either the passed-in socket connection or create a new one
  // with host details

  var socket = (0, _react.useMemo)(function () {
    return props.socket || new _reconnectingWebsocket["default"](props.host, [], {
      debug: false
    });
  }, [props.socket, props.host]); // subscribe to socket connection state

  (0, _react.useEffect)(function () {
    var onSocketClose = function onSocketClose() {
      return setSocketReady(false);
    };

    var onSocketOpen = function onSocketOpen() {
      return setSocketReady(true);
    };

    socket.addEventListener('close', onSocketClose);
    socket.addEventListener('open', onSocketOpen);
    return function () {
      socket.removeEventListener('close', onSocketClose);
      socket.removeEventListener('open', onSocketOpen);
    };
  }, [socket]);
  /* connect Sharedb to the server socket
      On reconnecting the socket to sharedb:
     https://github.com/share/sharedb/issues/121
      This is particularly useful:
     https://github.com/share/sharedb/issues/121#issuecomment-302754314
  */

  var connection = (0, _react.useMemo)(function () {
    return new _client["default"].Connection(socket);
  }, [socket]); // fetch the document for the given info

  var doc = (0, _react.useMemo)(function () {
    return connection.get(props.docCollection, props.docId.toString());
  }, [connection, props.docCollection, props.docId]);

  var _useState9 = (0, _react.useState)(null),
      _useState10 = _slicedToArray(_useState9, 2),
      quill = _useState10[0],
      setQuill = _useState10[1]; // needs to be instantiated after the first render
  // so that the div referenced by the ID has time to mount


  (0, _react.useEffect)(function () {
    var q = new _quill["default"]("#".concat(props.id), quillOptions);

    if (props.quillRef) {
      props.quillRef.current = q;
    }

    setQuill(q);
  }, [props.id, props.quillRef]);
  (0, _react.useEffect)(function () {
    if (!quill) return;

    var handleDocNotExists = function handleDocNotExists() {
      if (createAttempts > 5) {
        var tooManyAttempts = new Error('Too many attempts to subscribe to document');
        return setError(tooManyAttempts);
      }

      if (props.waitForCreate) {
        /*
          Only 1 person should be creating the document so there's no race condition.
          Perhaps a more elegant way - instead of retries - would be to receive
          an event when the document is ready.
        */
        doc.unsubscribe(onDocUnsubscribe);
        setTimeout(Math.pow(createAttempts + 1, 2) * 500, function () {
          setCreateAttempts(createAttempts + 1);
          doc.subscribe(onDocSubscribe);
        });
      } else {
        doc.create(props.initialData || [{
          insert: ''
        }], 'rich-text', function (error) {
          if (error) {
            console.error(error);
          }

          quill.setContents(doc.data);
          quill.history.clear();
        });
      }
    };

    var onDocSubscribe = function onDocSubscribe(error) {
      if (error) {
        setError(error);
        return console.error('Error subscribing', error);
      } // If doc.type is undefined, the document has not been created yet


      if (!doc.type) {
        handleDocNotExists();
      } else {
        quill.setContents(doc.data);
        /*
          Otherwise, undoing will erase everything after load
          https://stackoverflow.com/questions/59653962/stop-undo-from-clearing-everything-in-the-editor-quill-quilljs
        */

        quill.history.clear();
        setSubscribed(true);
      }

      quill.on('text-change', function (delta, oldDelta, source) {
        if (source !== 'user') return;
        doc.submitOp(delta, {
          source: quill
        });
      });
      doc.on('op', function (op, source) {
        if (source === quill) return;
        quill.updateContents(op);
      });
    };

    doc.subscribe(onDocSubscribe);

    var onDocUnsubscribe = function onDocUnsubscribe() {
      setSubscribed(false);
    };

    return function () {
      doc.unsubscribe(onDocUnsubscribe);
      connection.close();
      socket.close();
    };
  }, [quill, doc, props.initialData]);

  if (error) {
    console.error(error);
    return null;
  }

  var isEditorVisible = ready;
  var editorVisibility = isEditorVisible ? 'visible' : 'hidden';
  var spinnerVisibility = isEditorVisible ? 'hidden' : 'visible';
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: props.width,
      height: props.height,

      /*
        With quill's snow theme, the tool bar pushes the canvas down 41px.
        They are sized together in their container inside of quill (which is the <div id={props.id}> div),
        but the tool bar doesn't seem to consume its height from the parent.
        Manually pad things from the bottom to ensure correct scrolling in container of the editor.
         Fix proposed e.g. here https://stackoverflow.com/questions/57695124/how-to-resize-quill-editor-to-fit-inside-a-div
         Alternative?
        https://jsfiddle.net/pykm29bo/3/
      */
      paddingBottom: '41px'
    },
    "data-testid": "root"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      visibility: spinnerVisibility,
      height: '0px'
    },
    "data-testid": "spinner"
  }, props.spinner || /*#__PURE__*/_react["default"].createElement("div", null)), /*#__PURE__*/_react["default"].createElement("style", null, ".ql-container.ql-snow {\n          border-style: none;\n        }\n        .ql-toolbar.ql-snow {\n          border-bottom-width: 1px;\n          border-left-width: 0px;\n          border-right-width: 0px;\n          border-top-width: 0px;\n        }"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      visibility: editorVisibility
    },
    "data-testid": "editor"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontSize: props.fontSize || '18px'
    },
    id: props.id,
    "data-testid": "editor-container"
  })));
};

var _default = CollaborativeQuill;
exports["default"] = _default;